<section
  class="gallery-dialog"
  [ngClass]="{ 'gallery-dialog--mobile-sheet': isMobileView() }">
  <!-- dialog header -->
  <div class="gallery-dialog__header">
    <h4 class="gallery-dialog__title">{{ title | translate }}</h4>
    <button (click)="close()">
      <i class="iconsax gallery-dialog__icon" icon-name="x"></i>
    </button>
  </div>

  <!-- product images & videos -->
  <div class="gallery-dialog__media">
    <!-- main image and options menu -->
    <div class="gallery-dialog__preview">
      @if (
        selectedProductMedia && selectedProductMedia?.type?.includes('video')
      ) {
        <pwj-video-player
          class="preview-video"
          playBtnText=""
          [videoPreviewSrc]="selectedProductMedia?.url | imageSource"
          playBtnSize="small"></pwj-video-player>
      } @else {
        <img
          class="preview-image"
          [ngSrc]="selectedProductMedia?.url | imageSource"
          width="672"
          height="544"
          alt="main-img" />
      }
    </div>
    <!-- other images -->
    <ul class="gallery-dialog__other-media custom-scrollbar">
      @for (media of mediaData; track media._id) {
        <li class="other-media-item" (click)="onSelectMainImage(media)">
          @if (media?.type?.includes('video')) {
            <div class="other-media-item__frame">
              <pwj-simple-video-box
                class="other-media-item__video"
                [videoPreviewSrc]="media?.url | imageSource"
                playBtnSize="small"
                playBtnText=""
                [disableBtn]="true"></pwj-simple-video-box>
            </div>
          } @else {
            <div class="other-media-item__frame">
              <img
                class="other-media-item__img"
                [ngSrc]="
                  (useOriginalUrl
                    ? media?.url?.toLowerCase()
                    : media?.cropped_thumbnail?.toLowerCase() ||
                      media?.url?.toLowerCase()
                  ) | imageSource
                "
                [pwjMediaImageFallback]="media"
                [pwjMediaImageFallbackFrom]="
                  useOriginalUrl ? 'url' : 'cropped_thumbnail'
                "
                width="100"
                height="100"
                priority
                alt="" />
            </div>
          }
        </li>
      }
    </ul>
  </div>
</section>
